/**
 * F2-d cluster login multi-hotel: i 3 hotel reali serviti dal gestionale
 * online (api-edge). L'operatore sceglie l'hotel al login e l'`id` (tenant_id)
 * viene passato a `/auth/operators` e `/auth/login-pin`, che scopano gli
 * operatori e validano il PIN per quel tenant.
 *
 * NB: hardcoded di proposito (3 hotel fissi, nessun endpoint pubblico di
 * elenco tenant per non esporre la lista clienti). Gli id corrispondono ai
 * tenant seed in infrastructure/seeds/tenants/*.sql e agli HM_TENANT_ID negli
 * env-templates dei Mac Mini per-hotel.
 */
export type HotelOption = {
  /** tenant_id (UUID) — passato come hotelId alle API auth. */
  id: string;
  /** Nome visualizzato nella griglia di scelta. */
  name: string;
  /** Sottotitolo/località per disambiguare. */
  subtitle: string;
};

export const HOTELS: readonly HotelOption[] = [
  {
    id: '10000000-0000-0000-0000-000000000001',
    name: 'Privacy Hotel',
    subtitle: 'Reception',
  },
  {
    id: '10000000-0000-0000-0000-000000000002',
    name: 'Privacy One',
    subtitle: 'Reception',
  },
  {
    id: '10000000-0000-0000-0000-000000000003',
    name: 'Privacy Resort',
    subtitle: 'Reception',
  },
] as const;
